<template>
  <div>
    <div class="utils__title mb-3">
      <div class="tranTop">
        <strong class="text-uppercase font-size-16">Đánh giá cuộc hẹn</strong>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <a-table
              :data-source="feedback"
              :columns="columns"
              :rowKey="
                (record, index) => {
                  return index;
                }
              "
              :loading="loading"
              :pagination="false"
            >
              <div
                slot="filterDropdown"
                slot-scope="{
                  setSelectedKeys,
                  selectedKeys,
                  confirm,
                  clearFilters,
                  column,
                }"
                style="padding: 8px"
              >
                <a-input
                  v-ant-ref="(c) => (searchInput = c)"
                  :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]"
                  style="width: 188px; margin-bottom: 8px; display: block"
                  @change="
                    (e) =>
                      setSelectedKeys(e.target.value ? [e.target.value] : [])
                  "
                  @pressEnter="
                    () => handleSearch(selectedKeys, confirm, column.dataIndex)
                  "
                />
                <a-button
                  type="primary"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  @click="
                    () => handleSearch(selectedKeys, confirm, column.dataIndex)
                  "
                >
                  Search
                </a-button>
                <a-button
                  size="small"
                  style="width: 90px"
                  @click="() => handleReset(clearFilters)"
                >
                  Reset
                </a-button>
              </div>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : '#fb3072' }"
              />
              <template slot="stt" slot-scope="id, record, index">
                {{ index + 1 }}
              </template>
              <template slot="rate" slot-scope="rate">
                <a-rate disabled :default-value="rate" allow-half />
                <span class="rate-span">({{ rate }}/5.0)</span>
              </template>
            </a-table>
            <div class="pagination">
              <a-button :disabled="currentPage <= 1" @click="() => prevPage()"
                >prev</a-button
              >
              <a-button :disabled="disabledButtonNext" @click="() => nextPage()"
                >next</a-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      loading: false,
      feedback: [],
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      columns: [
        {
          title: "STT",
          width: "50px",
          dataIndex: "id",
          scopedSlots: { customRender: "stt" },
        },
        {
          title: "Name",
          dataIndex: "user",
          key: "user",
          width: "20%",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "customRender",
          },
          onFilter: (value, record) =>
            record.user.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },

        {
          title: "Content",
          dataIndex: "content",
          width: "30%",
          scopedSlots: { customRender: "content" },
        },
        {
          title: "Rate",
          dataIndex: "rate",
          scopedSlots: { customRender: "rate" },
        },
        {
          title: "Type",
          dataIndex: "type",
          width: "15%",
          scopedSlots: { customRender: "type" },
        },
      ],
    };
  },
  computed: {
    disabledButtonNext() {
      if (this.feedback.length < 10) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async loadData() {
      this.loading = true;
      await this.api("feedback/list")
        .then(async (res) => {
          console.log("Du lieu feedback", res);
          if (res) {
            this.feedback = res;
          }
        })
        .finally((e) => {
          this.loading = false;
        });
    },
    handleSearch(selectedKeys, confirm) {
      console.log(selectedKeys);
      confirm();
      this.loadData(selectedKeys[0]);
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    nextPage() {
      this.currentPage += 1;
      this.loading = true;
      this.api("feedback/list")
        .then((res) => {
          this.defaultData = this.feedback = res.sort(function (a, b) {
            return (
              new Date(b.created).getTime() - new Date(a.created).getTime()
            );
          });
        })
        .finally((e) => {
          this.loading = false;
        });
    },
    prevPage() {
      this.currentPage -= 1;
      this.loading = true;
      this.api("feedback/list")
        .then((res) => {
          this.defaultData = this.feedback = res.sort(function (a, b) {
            return (
              new Date(b.created).getTime() - new Date(a.created).getTime()
            );
          });
        })
        .finally((e) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadData();
  },
  mixins: [api, helper],
};
</script>
<style scoped>
a {
  color: #ff5254;
}
a:hover {
  color: #08f;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.pagination {
  float: right;
  margin: 16px 0;
}
</style>
